/* =========================================================
   BBX — Carousel + Wizard (POOL via AJAX) — vAJAX-1
   ✅ Pool real: /collections/{handle}/products.json (no límite 50)
   ✅ Wizard: respeta color+cat, mood prioritario, 8 resultados
   ✅ Lucky: 4 resultados
   ✅ iOS: scroll lock safe
   ========================================================= */
(function () {
  if (window.__BBX_CAROUSEL_AJAX_V1__) return;
  window.__BBX_CAROUSEL_AJAX_V1__ = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  function bootAll() {
    var roots = document.querySelectorAll('.bbx-section[data-bbx="1"]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__bbxInit) continue;
      roots[i].__bbxInit = true;
      try { initOne(roots[i]); } catch (e) { console.error("[BBX] init error", e); }
    }
  }

  function initOne(root) {
    var trackA = root.querySelector(".bbx-track--a");
    var trackB = root.querySelector(".bbx-track--b");
    var tracks = [trackA, trackB].filter(Boolean);
    if (!tracks.length) return;

    var btnPrev = root.querySelector(".bbx-prev");
    var btnNext = root.querySelector(".bbx-next");
    var btnSpin = root.querySelector("[data-spinshuffle]");
    var btnLucky = root.querySelector("[data-lucky]");
    var btnGuide = root.querySelector("[data-quiz-open]");
    var btnRestart = root.querySelector("[data-quiz-restart]");

    var sid = root.getAttribute("data-sid") || "";
    var modalWizard = document.getElementById("bbx-quiz-modal-" + sid);
    var modalLucky = document.getElementById("bbx-lucky-modal-" + sid);
    var modalResult = document.getElementById("bbx-result-modal-" + sid);

    function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

    /* ----------------- iOS scroll lock ----------------- */
    function lockScroll() {
      document.documentElement.classList.add("bbx-noscroll");
      document.body.classList.add("bbx-noscroll");
    }
    function unlockScroll() {
      document.documentElement.classList.remove("bbx-noscroll");
      document.body.classList.remove("bbx-noscroll");
    }

    function showModal(modal) {
      if (!modal) return;
      modal.style.display = "block";
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      lockScroll();
      var d = modal.querySelector('[role="dialog"]');
      if (d && d.focus) d.focus();
    }
    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      modal.style.display = "none";
      unlockScroll();
    }

    $all("[data-modal-close], .rexy__backdrop", root).forEach(function (el) {
      el.addEventListener("click", function () {
        var m = el.closest(".rexy-modal, .bbx-modal");
        if (m) closeModal(m);
      });
    });

    document.addEventListener("click", function (e) {
      var go = e.target.closest("[data-bbx-go-collections]");
      if (!go) return;
      e.preventDefault();
      closeModal(modalWizard);
      closeModal(modalLucky);
      closeModal(modalResult);
      window.location.href = go.getAttribute("href") || "/collections/all";
    });

    /* ----------------- carousel stepping ----------------- */
    function step(track, dir) {
      if (!track) return;
      var card = track.querySelector(".bbx-slide");
      var gap = 12;
      var w = card ? (card.getBoundingClientRect().width + gap) : 320;
      track.scrollBy({ left: (dir || 1) * w, behavior: "smooth" });
    }
    if (btnPrev) btnPrev.addEventListener("click", function () { tracks.forEach(function (t) { step(t, -1); }); });
    if (btnNext) btnNext.addEventListener("click", function () { tracks.forEach(function (t) { step(t, +1); }); });

    /* ----------------- POOL via AJAX ----------------- */
    var POOL = [];
    var poolHandle = (root.getAttribute("data-pool-handle") || "").trim();
    var poolMax = parseInt(root.getAttribute("data-pool-max") || "160", 10);
    if (!poolMax || poolMax < 1) poolMax = 160;

    function norm(v) { return String(v || "").toLowerCase().trim(); }

    function parseTagsToFields(tagsArr) {
      var out = { cat: "", color: "", mood: "", sex: "" };
      var tags = Array.isArray(tagsArr) ? tagsArr : String(tagsArr || "").split(",");
      for (var i = 0; i < tags.length; i++) {
        var low = norm(tags[i]);
        if (low.slice(0, 4) === "cat:") out.cat = out.cat || norm(low.slice(4));
        if (low.slice(0, 6) === "color:") out.color = out.color || norm(low.slice(6));
        if (low.slice(0, 5) === "mood:") out.mood = out.mood || norm(low.slice(5));
        if (low.slice(0, 4) === "sex:") out.sex = out.sex || norm(low.slice(4));
      }
      if (out.cat === "girls" && !out.sex) out.sex = "woman";
      return out;
    }

    function mapProduct(p) {
      var img = "";
      if (p && p.images && p.images.length) img = p.images[0].src || "";
      var fields = parseTagsToFields(p.tags);
      return {
        url: "/products/" + p.handle,
        handle: p.handle,
        title: p.title || "",
        img: img,
        cat: fields.cat,
        color: fields.color,
        mood: fields.mood,
        sex: fields.sex
      };
    }

    function fetchPoolPage(handle, page) {
      var url = "/collections/" + encodeURIComponent(handle) + "/products.json?limit=250&page=" + page;
      return fetch(url, { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (j) { return (j && j.products) ? j.products : []; });
    }

    function loadPool() {
      if (!poolHandle) {
        console.warn("[BBX] No pool handle (selecciona pool_collection en la sección).");
        console.log("[BBX] POOL loaded:", 0);
        return Promise.resolve([]);
      }
      var page = 1;
      var all = [];
      function next() {
        return fetchPoolPage(poolHandle, page).then(function (products) {
          if (!products || !products.length) return all;
          for (var i = 0; i < products.length; i++) {
            all.push(mapProduct(products[i]));
            if (all.length >= poolMax) break;
          }
          if (products.length >= 250 && all.length < poolMax) {
            page += 1;
            return next();
          }
          return all;
        });
      }
      return next().then(function (arr) {
        POOL = arr || [];
        console.log("[BBX] POOL loaded:", POOL.length, "handle:", poolHandle, "max:", poolMax);
        return POOL;
      }).catch(function (e) {
        console.error("[BBX] POOL ajax error:", e);
        POOL = [];
        console.log("[BBX] POOL loaded:", 0);
        return POOL;
      });
    }

    /* ----------------- Wizard logic ----------------- */
    var STATE = { mood: "", cat: "", color: "", sex: "", age: "" };

    function pickUnique(arr, n) {
      var out = [];
      var used = new Set();
      for (var i = 0; i < arr.length && out.length < n; i++) {
        var k = arr[i].handle || arr[i].url;
        if (used.has(k)) continue;
        used.add(k);
        out.push(arr[i]);
      }
      return out;
    }

    function filterBase(items, f) {
      // color y cat son los “hard rules” (lo que pide el cliente)
      return items.filter(function (x) {
        if (f.color && norm(x.color) !== f.color) return false;
        if (f.cat && norm(x.cat) !== f.cat) return false;

        // girls: NO depende de sex (el cliente pidió girls => girls)
        if (f.cat === "girls") return true;

        // sex: woman incluye woman + unisex (mejor experiencia)
        if (f.sex === "woman") return (x.sex === "woman" || x.sex === "unisex" || x.sex === "");
        if (f.sex === "unisex") return (x.sex === "unisex" || x.sex === "");
        // prefer not say => no filtra
        return true;
      });
    }

    function filterMood(items, mood) {
      if (!mood) return items;
      return items.filter(function (x) { return norm(x.mood) === mood; });
    }

    function buildResults() {
      var f = {
        mood: norm(STATE.mood),
        cat: norm(STATE.cat),
        color: norm(STATE.color),
        sex: norm(STATE.sex)
      };

      var base = filterBase(POOL, f);

      // 1) “mood priority”: intenta traer mínimo 3 con mood si existe
      var moodHits = f.mood ? filterMood(base, f.mood) : [];
      var res = [];

      if (moodHits.length) {
        // toma hasta 3 mood (o más si hay)
        res = res.concat(pickUnique(moodHits, Math.min(3, moodHits.length)));
      }

      // 2) completa hasta 8 con base (sin mood forzado)
      if (res.length < 8) {
        // mezcla base para variar
        var shuffled = base.slice().sort(function () { return Math.random() - 0.5; });
        res = res.concat(pickUnique(shuffled, 8 - res.length));
      }

      // 3) si aún no llega a 8: relaja sex (pero mantiene cat+color)
      if (res.length < 8) {
        var relaxedSex = POOL.filter(function (x) {
          if (f.color && norm(x.color) !== f.color) return false;
          if (f.cat && norm(x.cat) !== f.cat) return false;
          return true;
        }).sort(function () { return Math.random() - 0.5; });
        res = res.concat(pickUnique(relaxedSex, 8 - res.length));
      }

      // 4) último fallback: mismo color (mantener lo que el cliente pidió sí o sí)
      if (res.length < 8 && f.color) {
        var sameColor = POOL.filter(function (x) { return norm(x.color) === f.color; })
          .sort(function () { return Math.random() - 0.5; });
        res = res.concat(pickUnique(sameColor, 8 - res.length));
      }

      return pickUnique(res, 8);
    }

    function fillGrid(grid, items) {
      if (!grid) return;
      grid.innerHTML = "";
      if (!items || !items.length) {
        grid.innerHTML = '<div style="padding:18px;font-weight:700;">SIN RESULTADOS (revisa tags cat/color/mood/sex)</div>';
        return;
      }
      items.forEach(function (p) {
        var card = document.createElement("article");
        card.className = "rexy-card";
        card.innerHTML =
          '<a class="rexy-card__media" href="' + p.url + '">' +
            '<img loading="lazy" alt="' + escapeHtml(p.title) + '" src="' + (p.img || "") + '">' +
          '</a>' +
          '<div class="rexy-card__body">' +
            '<h4 class="rexy-card__title">' + escapeHtml(p.title) + '</h4>' +
            '<a class="rexy-card__cta" href="' + p.url + '">Ver producto</a>' +
          '</div>';
        grid.appendChild(card);
      });
    }

    function escapeHtml(s) {
      return String(s || "").replace(/[&<>"']/g, function (m) {
        return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" })[m];
      });
    }

    function resetWizardUI() {
      STATE.mood = ""; STATE.cat = ""; STATE.color = ""; STATE.sex = ""; STATE.age = "";
      if (btnRestart) btnRestart.hidden = true;
      if (!modalWizard) return;
      $all(".bbx-qpane", modalWizard).forEach(function (p, i) { p.classList.toggle("is-on", i === 0); });
      $all(".bbx-qopt", modalWizard).forEach(function (b) { b.classList.remove("is-picked"); });
    }

    function goNextPane() {
      if (!modalWizard) return;
      var panes = $all(".bbx-qpane", modalWizard);
      var idx = panes.findIndex(function (p) { return p.classList.contains("is-on"); });
      var next = Math.min(panes.length - 1, idx + 1);
      panes.forEach(function (p, i) { p.classList.toggle("is-on", i === next); });
    }

    function finishWizard() {
      closeModal(modalWizard);
      var items = buildResults();
      var grid = modalResult && modalResult.querySelector("[data-result-grid]");
      fillGrid(grid, items);
      showModal(modalResult);
      if (btnRestart) btnRestart.hidden = false;
    }

    function pickAnswer(paneKey, value) {
      var v = norm(value);

      if (paneKey === "mood") STATE.mood = v;
      if (paneKey === "cat") STATE.cat = v;
      if (paneKey === "color") STATE.color = v;
      if (paneKey === "sex") STATE.sex = v;
      if (paneKey === "age") STATE.age = v; // analytics only

      // termina en edad
      if (paneKey === "age") { finishWizard(); return; }
      goNextPane();
    }

    if (btnGuide) {
      btnGuide.addEventListener("click", function (e) {
        e.preventDefault();
        resetWizardUI();
        showModal(modalWizard);
      });
    }

    if (modalWizard) {
      modalWizard.addEventListener("click", function (e) {
        var opt = e.target.closest(".bbx-qopt");
        if (!opt) return;
        e.preventDefault();

        var pane = opt.closest(".bbx-qpane");
        var key = pane ? pane.getAttribute("data-pane") : "";
        var val = opt.getAttribute("data-value") || "";

        $all(".bbx-qopt", pane).forEach(function (b) { b.classList.remove("is-picked"); });
        opt.classList.add("is-picked");

        pickAnswer(key, val);
      });
    }

    if (btnRestart) {
      btnRestart.addEventListener("click", function (e) {
        e.preventDefault();
        resetWizardUI();
        showModal(modalWizard);
      });
    }

    /* ----------------- Lucky ----------------- */
    function pickLucky4() {
      if (!POOL.length) return [];
      var shuffled = POOL.slice().sort(function () { return Math.random() - 0.5; });
      return pickUnique(shuffled, 4);
    }

    if (btnLucky) {
      btnLucky.addEventListener("click", function (e) {
        e.preventDefault();
        var grid = modalLucky && modalLucky.querySelector("[data-lucky-grid]");
        fillGrid(grid, pickLucky4());
        showModal(modalLucky);
      });
    }

    /* ----------------- Spin button (visual only) ----------------- */
    if (btnSpin) {
      btnSpin.addEventListener("click", function (e) {
        e.preventDefault();
        // mini efecto: empuja carrusel
        tracks.forEach(function (t) {
          step(t, +1);
          setTimeout(function () { step(t, +1); }, 250);
        });
      });
    }

    /* ----------------- BOOT: load pool ----------------- */
    loadPool();
  }
})();

/* =========================================================
   BBX — Motion + Fast Spin + Shuffle (VISUAL ONLY)
   ✅ Autoscroll continuo (siempre se mueve)
   ✅ Botón "Girar" = ráfaga rápida + re-shuffle
   ✅ Randomiza orden al cargar (A y B)
   ✅ Pausa cuando el usuario toca / hover (UX)
   ✅ Respeta swipe en mobile
   ========================================================= */
(function () {
  if (window.__BBX_MOTION_V1__) return;
  window.__BBX_MOTION_V1__ = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  function boot() {
    document.querySelectorAll('.bbx-section[data-bbx="1"]').forEach(initOne);
  }

  function initOne(root) {
    if (root.__bbxMotionInit) return;
    root.__bbxMotionInit = true;

    const trackA = root.querySelector(".bbx-track--a");
    const trackB = root.querySelector(".bbx-track--b");
    const btnSpin = root.querySelector("[data-spinshuffle]");
    const tracks = [trackA, trackB].filter(Boolean);
    if (!tracks.length) return;

    /* ---------- helpers ---------- */
    const $all = (sel, ctx) => Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
    const rand = (a, b) => Math.floor(Math.random() * (b - a + 1)) + a;

    function shuffleChildren(track) {
      const kids = $all(".bbx-slide", track);
      if (kids.length < 2) return;
      for (let i = kids.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = kids[i];
        kids[i] = kids[j];
        kids[j] = tmp;
      }
      const frag = document.createDocumentFragment();
      kids.forEach((k) => frag.appendChild(k));
      track.appendChild(frag);
    }

    function getStep(track) {
      const card = track.querySelector(".bbx-slide");
      const gap = 14; // debe parecerse al CSS gap
      const w = card ? (card.getBoundingClientRect().width + gap) : 320;
      return Math.max(180, w * 0.85);
    }

    /* ---------- Randomize on load ---------- */
    shuffleChildren(trackA);
    shuffleChildren(trackB);

    /* ---------- Autoscroll (smooth, always moving) ---------- */
    let rafId = null;
    let pausedUntil = 0;

    // velocidad base (px/frame). 0.6–1.4 se siente premium.
    const SPEED_A = 0.95;
    const SPEED_B = 1.05;

    function tick() {
      const now = Date.now();
      if (now < pausedUntil) {
        rafId = requestAnimationFrame(tick);
        return;
      }

      // Autoscroll: A → derecha, B → izquierda
      if (trackA) autoScroll(trackA, +SPEED_A);
      if (trackB) autoScroll(trackB, -SPEED_B);

      rafId = requestAnimationFrame(tick);
    }

    function autoScroll(track, dx) {
      if (!track) return;

      // Si llega al final, reordena y regresa al inicio para que parezca infinito
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;

      const next = track.scrollLeft + dx;

      // derecha
      if (dx > 0 && next >= max - 2) {
        shuffleChildren(track);
        track.scrollLeft = 0;
        return;
      }

      // izquierda
      if (dx < 0 && next <= 2) {
        shuffleChildren(track);
        track.scrollLeft = max;
        return;
      }

      track.scrollLeft = next;
    }

    function pause(ms) {
      pausedUntil = Date.now() + (ms || 1500);
    }

    // Pausa por interacción (swipe/touch/scroll)
    tracks.forEach((t) => {
      t.addEventListener("pointerdown", () => pause(2200), { passive: true });
      t.addEventListener("touchstart", () => pause(2200), { passive: true });
      t.addEventListener("wheel", () => pause(1200), { passive: true });
      t.addEventListener("scroll", () => pause(900), { passive: true });
      // hover desktop
      t.addEventListener("mouseenter", () => pause(999999));
      t.addEventListener("mouseleave", () => pause(10));
    });

    // Arranca motion
    rafId = requestAnimationFrame(tick);

    /* ---------- Fast "Girar" burst ---------- */
    function burstSpin() {
      pause(0);

      const dur = 900;              // duración total
      const start = performance.now();
      const stepA = trackA ? getStep(trackA) : 320;
      const stepB = trackB ? getStep(trackB) : 320;

      // antes del burst: shuffle fuerte para que se vea random REAL
      if (trackA) { shuffleChildren(trackA); trackA.scrollLeft = rand(0, Math.max(0, trackA.scrollWidth - trackA.clientWidth)); }
      if (trackB) { shuffleChildren(trackB); trackB.scrollLeft = rand(0, Math.max(0, trackB.scrollWidth - trackB.clientWidth)); }

      function frame(now) {
        const t = (now - start) / dur;
        if (t >= 1) {
          // termina y vuelve a autoscroll
          pause(300);
          return;
        }

        // easing (rápido al inicio, frena al final)
        const ease = 1 - Math.pow(1 - t, 3);

        if (trackA) trackA.scrollLeft += (stepA * 0.18) + (1 - ease) * 22;
        if (trackB) trackB.scrollLeft -= (stepB * 0.18) + (1 - ease) * 22;

        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    if (btnSpin) {
      btnSpin.addEventListener("click", function (e) {
        e.preventDefault();
        burstSpin();
      });
    }
  }
  
  
})();
